/**
 * It must be same as TopOfferType.
 * TODO replace by TopOfferType
 */
export enum TopOfferType {
    None = 0,
    TopPonuka = 1,
    TopBets = 2,
    HotBets = 3,
    EventTopTips = 4,
    PreparedTicket = 5,
    TopLive = 6,
    CustomCategory = 7,
    Top5PerDay = 8,
    Top10PerDay = 9
}